module.exports = __webpack_public_path__ + "img/features_cards.d02d553e.png";